import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight, Download } from "lucide-react";
import { RESUME_URL } from "../data/services";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative z-10 border-t border-black/10 bg-[#f4f3ee]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-8 w-8 grid place-items-center bg-[#111111] text-white font-mono-tech text-sm">
                R
              </span>
              <span className="font-head font-bold tracking-tight text-lg text-[#111111]">
                Rye<span className="text-[#2f4bff]">.</span>Software Services
              </span>
            </div>
            <p className="mt-5 text-neutral-600 font-body max-w-sm leading-relaxed">
              Enterprise .NET modernization and cloud architecture. Built by
              Shawn Rye — 13+ years turning legacy systems into scalable
              software.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#2f4bff] mb-5">
              Navigate
            </p>
            <ul className="space-y-3 font-body text-neutral-600">
              <li>
                <Link to="/" className="hover:text-[#111111] link-underline">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-[#111111] link-underline"
                >
                  Work Items
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-[#111111] link-underline"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#2f4bff] mb-5">
              Get in touch
            </p>
            <a
              href="mailto:shawnrye@hotmail.com"
              data-testid="footer-email"
              className="flex items-center gap-3 text-neutral-700 hover:text-[#111111] mb-3"
            >
              <Mail className="h-4 w-4 text-[#2f4bff]" />
              shawnrye@hotmail.com
            </a>
            <a
              href="tel:4017440703"
              data-testid="footer-phone"
              className="flex items-center gap-3 text-neutral-700 hover:text-[#111111]"
            >
              <Phone className="h-4 w-4 text-[#2f4bff]" />
              401-744-0703
            </a>
            <Link
              to="/contact"
              className="group inline-flex items-center gap-2 mt-6 font-mono-tech text-xs uppercase tracking-[0.15em] text-[#111111] border border-black/20 px-5 py-3 hover:border-[#2f4bff] hover:text-[#2f4bff] transition-colors"
            >
              Contact me
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
            {/* Résumé download temporarily hidden — restore by uncommenting.
            <a
              href={RESUME_URL}
              download
              data-testid="footer-resume-download"
              className="group inline-flex items-center gap-2 mt-3 ml-0 sm:ml-3 font-mono-tech text-xs uppercase tracking-[0.15em] text-[#111111] border border-black/20 px-5 py-3 hover:border-[#2f4bff] hover:text-[#2f4bff] transition-colors"
            >
              <Download className="h-4 w-4" />
              Download résumé
            </a>
            */}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-black/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono-tech text-xs text-neutral-500">
            © {new Date().getFullYear()} Rye Software Services.
          </p>
          <p className="font-mono-tech text-xs text-neutral-500">
            Engineered with .NET precision.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
